import * as React from 'react';
import { FC } from 'react';
import money from 'app/helpers/money';
import useBonus, { Bonus } from './useBonus';

type FreebetBonusesProps = {
  amount: Bonus['amount'];
  status: Bonus['status'];
  locales: Record<string, string>;
  currency: string;
};

const FreebetBonuses: FC<FreebetBonusesProps> = (props) => {
  const { amount, status } = useBonus(props.amount, props.status);
  const { locales } = props;
  const currency = props.currency.toLowerCase();

  const classes = () => [(status || '').toLowerCase(), 'freebet'].join(' ');

  const bonus = () => (
    <a href="/" className={classes()}>
      <div className="text">
        <div>{locales.freebet}</div>
        {money(amount || 0, currency)}
      </div>
      <div className="icon">{status === 'Accepted' ? <i title="accepted" className="rs-icon-hourglass" /> : null}</div>
    </a>
  );

  const activate = () => (
    <a className="activate" href="/sport_bonuses">
      <span>{locales.activate_large}</span>
    </a>
  );

  switch (status) {
    case 'Pending':
      return activate();
    case 'Accepted':
    case 'Activated':
      return bonus();
    default:
      return <div />;
  }
};

export default FreebetBonuses;
